{
  "myCases.detail.back": "Tillbaka till listan",
  "myCases.detail.employer": "Arbetsgivare",
  "myCases.detail.heading": "Meddelandets uppgifter",
  "myCases.detail.source": "Källa",
  "myCases.detail.closedReplyNote": "Den här konversationen är stängd och kan inte längre besvaras. Om du fortfarande behöver hjälp kan du kontakta oss genom att inleda en ny konversation.",
  "myCases.detail.notFound": "Meddelandet hittades inte.",
  "myCases.detail.unavailable": "Det går inte att hämta meddelandeuppgifterna just nu. Försök igen senare.",
  "myCases.detail.messagesHeading": "Meddelanden",
  "myCases.detail.noMessages": "Inga meddelanden.",
  "myCases.detail.systemAuthor": "YTK Työelämä",
  "myCases.detail.selfAuthor": "Du",
  "myCases.detail.contactSummaryHeading": "Din kontakt",
  "myCases.detail.attachmentsHeading": "Bilagor",
  "myCases.detail.download": "Ladda ner",
  "myCases.detail.attachmentBeingChecked": "Bilagan säkerhetskontrolleras och kan inte laddas ner just nu.",
  "myCases.detail.downloadFailed": "Det gick inte att ladda ner. Försök igen senare.",
  "myCases.detail.replyLabel": "Svara",
  "myCases.detail.replyPlaceholder": "Skriv ditt svar…",
  "myCases.detail.removeAttachment": "Ta bort bilaga",
  "myCases.detail.uploadTooMany": "För många bilagor. Ta bort en före sändning.",
  "myCases.detail.replySend": "Skicka svar",
  "myCases.detail.replySending": "Skickar…",
  "myCases.detail.replySent": "Svaret har skickats.",
  "myCases.detail.replyFailed": "Det gick inte att skicka svaret just nu. Försök igen.",
  "myCases.detail.replyEmpty": "Skriv ett meddelande eller lägg till en bilaga innan du skickar.",
  "myCases.detail.replyTooLong": "Svaret är för långt (högst 4 000 tecken). Förkorta det.",
  "myCases.detail.uploadLabel": "Lägg till bilaga (PDF, PNG, JPEG, DOCX eller XLSX, högst 25 MB)",
  "myCases.detail.chooseFile": "Välj fil",
  "myCases.detail.attachmentCountHint": "Högst {max} bilagor ({count} valda)",
  "myCases.detail.charCountUnit": "tecken",
  "myCases.detail.uploadBeingChecked": "Bilagan har skickats. Den säkerhetskontrolleras och kan inte laddas ner ännu.",
  "myCases.detail.uploadTooLarge": "Filen är för stor. Prova en mindre fil.",
  "myCases.detail.uploadUnsupported": "Filtypen stöds inte. Tillåtna filtyper: PDF, PNG, JPEG, DOCX och XLSX.",
  "myCases.detail.uploadFailed": "Det gick inte att skicka bilagan just nu. Försök igen.",
  "myCases.empty": "Du har inga meddelanden ännu.",
  "myCases.heading": "Mina meddelanden",
  "myCases.source.ai_originated": "Från Lakikaveri-konversationen",
  "myCases.source.standalone_contact": "Formuläret Kontakta oss",
  "myCases.status.acknowledged": "Mottaget",
  "myCases.status.closed": "Avslutat",
  "myCases.status.created": "Skapat",
  "myCases.status.failed": "Misslyckat",
  "myCases.status.routed": "Hänvisat för behandling",
  "myCases.loading": "Laddar…",
  "myCases.unavailable": "Det går inte att hämta dina meddelanden just nu. Försök igen senare.",
  "myCases.untitled": "Namnlöst meddelande",
  "myCases.unread": "Oläst",
  "myCases.statusPrefix": "Status:",
  "myCases.loadMore": "Ladda fler meddelanden",
  "myCases.loadingMore": "Laddar fler meddelanden…",
  "myCases.moreLoaded": "Fler meddelanden har laddats. {count} meddelanden visas nu.",
  "myCases.allShown": "Alla meddelanden visas.",
  "myCases.loadMoreFailed": "Det gick inte att ladda fler meddelanden just nu. Försök igen."
}
